var _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoolIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 64,
    viewBox: "0 0 120 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9333 10.8205C50.9603 16.4548 47.9428 23.856 47.9428 31.9619C47.9428 40.0679 50.9603 47.469 55.9333 53.1034C50.0767 59.7388 41.508 63.9238 31.9619 63.9238C14.3098 63.9238 0 49.614 0 31.9619C0 14.3098 14.3098 0 31.9619 0C41.508 0 50.0767 4.18503 55.9333 10.8205Z",
    fill: "#091F38"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.0381,
    cy: 31.9619,
    r: 31.9619,
    fill: "#949BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9819 31.9612L23.9724 39.9517L41.951 23.9707",
    stroke: "#F8F8F8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0525 19.9785L100.024 43.9499",
    stroke: "#F8F8F8",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.024 19.9785L76.053 43.9499",
    stroke: "#F8F8F8",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoolIcon);
export default __webpack_public_path__ + "static/media/bool-icon.c67e5051f44bdf8f513626f61668ef2e.svg";
export { ForwardRef as ReactComponent };